module.exports = __webpack_public_path__ + "main/assets/public/animated-squiggle/squiggle.0d1ccf8137f81dca.svg";